import { Navigate } from "react-router-dom";
import useUserStore from "../store/stores/auth"; // renamed to improve clarity

const ProtectedRoute = ({ children }) => {
  const auth = useUserStore((state) => state.auth);
  const hasHydrated = useUserStore.persist?.hasHydrated?.();
  

  if (!hasHydrated) {
    // Prevent rendering until Zustand is rehydrated from localStorage
    return null; // You can also return a spinner/loader here
  }

  if (!auth?.isAuthenticated || !auth?.token || !auth?.profile) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
